import {BaseMenuHelpers} from "../base-menu/base-menu-helpers";
import {getTextMenuItem} from "./get-text-menu-item";
import {getLinkMenuItem} from "./get-link-menu-item";

export class VerticalMenuHelpers extends BaseMenuHelpers {
  static getTextMenuItem = getTextMenuItem;
  static getLinkMenuItem = getLinkMenuItem;
}